import { render, staticRenderFns } from "./PaginaInternaLicitacao.vue?vue&type=template&id=06ce5514&scoped=true&"
import script from "./PaginaInternaLicitacao.vue?vue&type=script&lang=js&"
export * from "./PaginaInternaLicitacao.vue?vue&type=script&lang=js&"
import style0 from "./PaginaInternaLicitacao.vue?vue&type=style&index=0&id=06ce5514&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce5514",
  null
  
)

export default component.exports